import React from 'react'

// third party components

// images and icons
import EditMetaIcon from 'assets/icons/edit-meta-22x22.svg?component'
import EnablePrintIcon from 'assets/icons/enable-print-icon.svg?component'
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import SolanaFMIcon from 'assets/icons/solana-fm-icon-15x22.svg?component'

// styles
import styles from './index.module.scss'

interface MenuEditPageProps {
  studio: boolean
  metadata: boolean
  explorerURL: any
  merchToggle: boolean
  isCreatedNft: boolean
  setShowNftMeta: any
  setCreateMerchModal: any
  setRemoveMerchModal: any
  setOpenShareModal: any
}

const MenuEditPage = ({
  studio,
  metadata,
  merchToggle,
  explorerURL,
  isCreatedNft,
  setShowNftMeta,
  setCreateMerchModal,
  setRemoveMerchModal,
  setOpenShareModal,
}: MenuEditPageProps) => {
  return (
    <div className={styles.menuArea}>
      {isCreatedNft && (
        <div
          className={`${styles.menuItem}`}
          onClick={() => {
            setShowNftMeta(true)
          }}
        >
          <div className="flex gap-[15px] items-center">
            <div className={styles.itemIcon}>
              <EditMetaIcon alt="" />
            </div>
            <div>
              <div className={styles.itemTitle}>Edit Metadata</div>
              <div className={styles.itemDescription}>Update attributes of this artwork</div>
            </div>
          </div>
          <div className={styles.separator} />
        </div>
      )}
      {isCreatedNft && metadata && (
        <div
          className={`${styles.menuItem} ${studio ? '' : 'opacity-[80%]'}`}
          onClick={() => {
            if (!studio) return
            if (merchToggle) {
              if (isCreatedNft) setRemoveMerchModal(true)
            } else if (isCreatedNft) setCreateMerchModal(true)
          }}
        >
          <div className="flex gap-[15px] items-center">
            <div className={styles.itemIcon}>
              <EnablePrintIcon alt="" />
            </div>
            <div>
              <div className={styles.itemTitle}>
                {merchToggle ? 'Disable Physical Prints' : 'Enable Physical Prints'}
              </div>
              <div className={styles.itemDescription}>Earn commission on physical prints</div>
            </div>
          </div>
          <div className={styles.separator} />
        </div>
      )}

      <div
        className={`${styles.menuItem} ${studio ? '' : 'opacity-[80%]'}`}
        onClick={() => {
          setOpenShareModal(true)
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Artwork</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
        <div className={styles.separator} />
      </div>

      <div
        className={`${styles.menuLastItem} ${studio ? '' : 'opacity-[80%]'}`}
        onClick={() => {
          window.open(explorerURL)
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <SolanaFMIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>View on SolanaFM</div>
            <div className={styles.itemDescription}>See transaction details and history</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuEditPage
